import { _x } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

const resultsWrapper = document.querySelector('.persona-results');
const labels = document.querySelectorAll('.filters-persona__filter-label');

document.addEventListener('facetwp-loaded', function () {
  if ('undefined' !== typeof window.FWP && resultsWrapper) {
    resultsWrapper.classList.remove('persona-results--loading');
    const status = resultsWrapper.querySelector('.persona-results__status');

    const personaFacet = window.FWP.facets.page_persona;
    const serviceFacet = window.FWP.facets.page_service;

    if (0 < labels.length) {
      labels.forEach((label) => {
        label.classList.remove('label--loading');
      });
    }

    if (0 < personaFacet.length && 0 < serviceFacet.length) {
      resultsWrapper.classList.remove('persona-results--hidden');
      status.textContent = _x(
        'Custom suggestions have been updated',
        'search results status',
        'vtx'
      );
      resultsWrapper.focus();
    } else {
      resultsWrapper.classList.add('persona-results--hidden');
      status.textContent = _x(
        'Fill in all select fields to get customized results',
        'search results status',
        'vtx'
      );
    }
  }
});

domReady(() => {
  if (0 < labels.length) {
    labels.forEach((label) => {
      label.classList.remove('label--hidden');
    });
  }
});

document.addEventListener('facetwp-refresh', function () {
  if ('undefined' !== typeof window.FWP && resultsWrapper) {
    resultsWrapper.classList.add('persona-results--loading');
  }
  if (0 < labels.length) {
    labels.forEach((label) => {
      label.classList.add('label--loading');
    });
  }
});
